import React from 'react';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';
import Form from '../Form';
import InputFirstName from '../InputNameFirst';
import InputLastName from '../InputNameLast';
import InputAddressStreet from '../InputAddressStreet';
import InputAddressSecondary from '../InputAddressSecondary';
import InputAddressCity from '../InputAddressCity';
import InputAddressState from '../InputAddressState';
import InputAddressZipCode from '../InputAddressZipCode';
import InputDOB from '../InputDOB';
import InputTIN from '../InputTIN';
import ButtonPrimary from '../ButtonPrimary';
import Disclaimers from '../Disclaimers';

import usePrequal from '../../resources/prequal/usePrequal';
import useForm from './useForm';

const PIIRetry = () => {
  useRUMView('pre-unverified');
  const { data: prequal } = usePrequal();

  const {
    form,
    handleSubmit,
    isSubmitting,
  } = useForm();

  return (
    <Screen
      header="Let's double-check your information."
      subheader="It's important to ensure your information is correct before proceeding."
    >
      <Form
        form={form}
        onSubmit={handleSubmit}
      >
        <InputFirstName prefill={prequal.firstName} />
        <InputLastName prefill={prequal.lastName} />
        <InputAddressStreet prefill={prequal.street} />
        <InputAddressSecondary prefill={prequal.secondary} />
        <InputAddressCity prefill={prequal.city} />
        <InputAddressState prefill={prequal.state} />
        <InputAddressZipCode prefill={prequal.zipCode} />
        <InputDOB />
        <InputTIN />
        <Disclaimers textAlign="center">
          This entry is safe, secure, and won&apos;t impact your credit score.
        </Disclaimers>
        <ButtonPrimary isLoading={isSubmitting}>
          Continue
        </ButtonPrimary>
      </Form>
    </Screen>
  );
};

export default PIIRetry;
